import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";
import "../../css/Employee.css";

const DealerDetails = () => {
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(10);
  const [showListFilter, setShowListFilter] = useState(false);
  const [zoomImageUrl, setZoomImageUrl] = useState(null);

  const listFilterRef = useRef(null);

  useEffect(() => {
    api
      .get("/get/dealer/data")
      .then((response) => {
        if (response.data.success) {
          setOrderData(response.data.data);
          setFilteredData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching dealers:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let dataToFilter = orderData;

    if (searchTerm.trim() !== "") {
      const search = searchTerm.toLowerCase();
      dataToFilter = orderData.filter((dealer) => {
        return (
          (dealer.dealer_name || "").toLowerCase().includes(search) ||
          (dealer.firm_name || "").toLowerCase().includes(search) ||
          (dealer.brand || "").toLowerCase().includes(search) ||
          (dealer.phone || "").toLowerCase().includes(search) ||
          (dealer.address || "").toLowerCase().includes(search) ||
          (dealer.sale || "").toLowerCase().includes(search) ||
          (dealer.state || "").toLowerCase().includes(search) ||
          (dealer.data || "").toLowerCase().includes(search) ||
          (dealer.meeting_note || "").toLowerCase().includes(search)
        );
      });
    }

    setFilteredData(dataToFilter);
    setCurrentPage(1);
  }, [searchTerm, orderData]);

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = filteredData.slice(
    indexOfFirstEmployee,
    indexOfLastEmployee
  );
  const totalPages = Math.ceil(filteredData.length / employeesPerPage);

  const handlePerPageChange = (value) => {
    setEmployeesPerPage(value);
    setShowListFilter(false);
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        listFilterRef.current &&
        !listFilterRef.current.contains(event.target)
      ) {
        setShowListFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeZoomModal = () => {
    setZoomImageUrl(null);
  };

  return (
    <section className="employee-section">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Dealer Details</h2>
          <div className="right-filter">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="list-fliter tooltip-wrapper" ref={listFilterRef} data-tooltip="Filter by List">
              <button onClick={() => setShowListFilter(!showListFilter)}>
                <i className="fa-solid fa-filter"></i>
              </button>
              {showListFilter && (
                <div className="filter-data">
                  {[10, 30, 50, 100].map((number) => (
                    <div
                      key={number}
                      className={`filter-option ${
                        employeesPerPage === number ? "selected" : ""
                      }`}
                      onClick={() => handlePerPageChange(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Dealer Name</th>
                    <th>Firm Name</th>
                    <th>Brand</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Sale</th>
                    <th>State</th>
                   
                  </tr>
                </thead>
                <tbody>
                  {currentEmployees.map((dealer, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstEmployee + index + 1}</td>
                      <td>{dealer.dealer_name || "N/A"}</td>
                      <td className="check-in">{dealer.firm_name || "N/A"}</td>
                      <td className="p-day">{dealer.brand || "N/A"}</td>
                      <td className="phone"><i className="fa-solid fa-phone"></i>&nbsp;{dealer.phone || "N/A"}</td>
                      <td className="address">{dealer.address || "N/A"}</td>
                      <td className="check-in">{dealer.sale || "N/A"}</td>
                      <td className="state">{dealer.state || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}

        {zoomImageUrl && (
          <div className="zoom-modal-overlay" onClick={closeZoomModal}>
            <div
              className="zoom-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeZoomModal}>
                <i className="fa-solid fa-xmark"></i>
              </button>
              <img src={zoomImageUrl} alt="Zoomed" className="zoomed-image" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DealerDetails;
